import React from "react";
import "./documentsModalV2.sass";

export const DocumentsModalBody = ({ children, className = "" }) => (
  <div className={`DocumentsModalV2__body ${className}`.trim()}>{children}</div>
);

export const DocumentsModalSingleFooterButton = ({ children, onClick, variant = "primary" }) => (
  <div className="DocumentsModalV2__singleFooter">
    <button
      type="button"
      className={`ModalV2Buttons__btn ModalV2Buttons__btn--${variant} DocumentsModalV2__singleFooterBtn`}
      onClick={onClick}
    >
      {children}
    </button>
  </div>
);
